import PositionInformation from './position_information.vue';

export default PositionInformation;
